"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lazy_1 = __importDefault(require("react-player/lazy"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var icon_1 = __importDefault(require("../../icon"));
var ReactPlayer = lazy_1.default;
function VideoMask(props) {
    var source = props.source, onClose = props.onClose;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    function handleClose() {
        onClose();
    }
    return (react_1.default.createElement("div", { className: "".concat(classPrefix, "-image-video-mask") },
        react_1.default.createElement("div", { className: "video-wrapper" },
            react_1.default.createElement(ReactPlayer, { url: source, controls: true, volume: 0.6, width: 850, height: 640 })),
        react_1.default.createElement("span", { onClick: handleClose, className: "mask-close" },
            react_1.default.createElement(icon_1.default, { name: "close", size: 32, color: "#fff" }))));
}
exports.default = VideoMask;
//# sourceMappingURL=VideoMask.js.map